import React from 'react';
import { Grid } from '@mui/material';
import ContractPricingModifier from './ContractPricingModifier';

const ContractPricingModifiers = ({ name }) => {
    return (
        <Grid
            container
            direction="row"
            sx={{
                justifyContent: 'flex-start',
                alignItems: 'center',
                paddingTop: '20px',
            }}
            spacing={2}
        >
            <Grid item xs={6}>
                <ContractPricingModifier modifierName={name} />
            </Grid>
        </Grid>
    );
};

export default ContractPricingModifiers;
